/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IView, IViewEditable } from "./IView";
import { isFunction } from "@adapptio/lib-shared";

export function isViewEditable(view: IView | IViewEditable): view is IViewEditable {
	return isFunction((view as IViewEditable).save);
}
